export default __webpack_public_path__ + "static/media/pengaduan.be3a859d.png";